// 基本項目/明細の値変更ハンドラと、それに伴う連動処理をまとめる。
// 本文は HinbanMaster.js から移設したもの。

export function createValueChangedService(deps) {
    const {
        BRAND_HINBAN_COLUMNID,
        DicVal,
        GridData,
        HINBAN_GENKA_PANEL_TYPE,
        KAKOUSIJI_ANCHOR_PANEL_TYPE,
        KAKOUSIJI_DEMAND_JUTYU_PANEL_TYPE,
        KAKOUSIJI_DEMAND_NOUHIN_PANEL_TYPE,
        KAKOUSIJI_FUKUSHIZAI_BASE_PANEL_TYPE,
        KAKOUSIJI_FUKUSHIZAI_LIST_PANEL_TYPE,
        KAKOUSIJI_FUZOKU_MEISAI_PANEL_TYPE,
        KAKOUSIJI_SAMPLE_INFO_PANEL_TYPES,
        KAKOUSIJI_SIJISU_PANEL_TYPE,
        KAKOUSIJI_SOZAI_MEISAI_PANEL_TYPE,
        PDTC_SIZE_PATTERN_REQUIRED_MESSAGE,
        PDT_SIZE_PATTERN_FIELD_IDS,
        SUB_BRAND_COLUMNID,
        SUSTAINABLE_IMAGE_FILE_FIELD,
        activeKakousijiSummaryItem,
        applyCostRateToEntryData,
        applyKakousijiBaseUpdatesToCurrentContext,
        applyKakousijiGroupSelectionToRow,
        applyPdtSizePatternOptions,
        applyPdtcSizeOptions,
        applyRotRoundRuleToEntryData,
        applySubBrandNameToEntryData,
        applyZaikoHyokaKbnFromShohinKbn,
        clearPdtTenkaiCodeValue,
        columninfo,
        currentPdtSizePatternCode,
        dispatch,
        entrydata,
        entrydataRef,
        entryrerender,
        entrytriggercall,
        fnc,
        formstatus,
        getEntryDataValue,
        handleBrandHinbanSerialSelection,
        isEmpty,
        isKakousijiGroupManagedPanelType,
        isKakousijiPanelType,
        lastSeasonValueRef,
        loadBitmSubCode,
        loadBrandGroupInfo,
        loadColorMasterInfo,
        loadHinbanFixEnableByBrand,
        loadJanSeasonCode,
        loadJyutakuSupplierInfo,
        loadPdtSizePatternOptions,
        loadPdtSizePatternSizeOptions,
        loadPdtTenkaiCodeOptionsForData,
        loadPdtTenkaiSizePatternInfo,
        loadQrcSyohinBunruiCd,
        loadQrcSyohinComent,
        loadSustainableImageFromServer,
        loadUserAllowedBrandDepartment,
        matchesColumnId,
        matchesColumnToken,
        normalizeKakousijiDemandRows,
        pdtTenkaiCodeChangedAfterLoadRef,
        recalcHinbanGenkaGridAndSummary,
        recalcKakousijiAccessoryDetailCalcRows,
        recalcKakousijiFukushizaiListCalcRows,
        recalcKakousijiMaterialDetailCalcRows,
        recalcKakousijiSijisuTotalRows,
        refreshControlDate,
        refreshKakousijiSummaryState,
        refreshPdtSizePatternEditableState,
        resolveKakousijiActiveGroupSelection,
        resolveKakousijiRepresentativePanelTypeByFieldId,
        resolveKakousijiSummaryTargetSsdNo,
        seasonChangeTimerRef,
        setEntryGridRows,
        setSectionEditRenderVersion,
        settextfields,
        settextfieldsall,
        shouldRefreshHinbanGenkaByColumnId,
        shouldSyncKakousijiSummaryByFieldId,
        storeRowData,
        syncHinbanGenkaCurrencyState,
        syncHinbanGenkaPatternByEntry,
        syncItemDependentData,
        syncKakousijiRepresentativeEntryProjection,
        syncKakousijiSamplePanelsFromPdtc,
        syncMakerHyojyunJyodaiFromPrice,
        syncPdtBrandCodeAlias
    } = deps;

    function applyKakousijiDetailPostEdit(panel) {
        const panelType = String(DicVal(panel, 'type', '')).trim();
        if (panelType === '') return;
        const currentRows = GridData(panel);
        if (!Array.isArray(currentRows)) return;
        if (panelType === KAKOUSIJI_SIJISU_PANEL_TYPE) {
            recalcKakousijiSijisuTotalRows(panel);
            return;
        }
        if (KAKOUSIJI_SAMPLE_INFO_PANEL_TYPES.includes(panelType)) {
            setSectionEditRenderVersion((prev) => prev + 1);
            return;
        }
        if (panelType === KAKOUSIJI_SOZAI_MEISAI_PANEL_TYPE) {
            setEntryGridRows(panel, recalcKakousijiMaterialDetailCalcRows(currentRows));
            fnc.current.modify(true);
            return;
        }
        if (panelType === KAKOUSIJI_FUZOKU_MEISAI_PANEL_TYPE) {
            setEntryGridRows(panel, recalcKakousijiAccessoryDetailCalcRows(currentRows));
            fnc.current.modify(true);
            return;
        }
        if (panelType === KAKOUSIJI_FUKUSHIZAI_LIST_PANEL_TYPE) {
            setEntryGridRows(panel, recalcKakousijiFukushizaiListCalcRows(currentRows));
            fnc.current.modify(true);
            return;
        }
        if (panelType === KAKOUSIJI_DEMAND_JUTYU_PANEL_TYPE || panelType === KAKOUSIJI_DEMAND_NOUHIN_PANEL_TYPE) {
            setEntryGridRows(panel, normalizeKakousijiDemandRows(panel, currentRows));
            fnc.current.modify(true);
        }
    }
    function ListValueChanged(params, panel) {
        const panelType = String(DicVal(panel, "type", "")).trim();
        if (isKakousijiGroupManagedPanelType(panelType)) {
            applyKakousijiGroupSelectionToRow(panelType, DicVal(params, 'data', null));
        }
        storeRowData(panel);
        if (isEmpty(params) || isEmpty(params.colDef)) return;
        const id = String(isEmpty(params.colDef.colId) ? DicVal(params.colDef, "field", "") : params.colDef.colId);
        ValueChanged(id, params.newValue, true, { targetData: params.data, rowNode: params.node, panel: panel });
        if (panelType === KAKOUSIJI_FUKUSHIZAI_BASE_PANEL_TYPE) {
            const selection = resolveKakousijiActiveGroupSelection(panelType);
            syncKakousijiRepresentativeEntryProjection(panelType, selection);
        }
        if (panelType === "200") {
            syncKakousijiSamplePanelsFromPdtc();
        }
        if (panelType === "210") refreshPdtSizePatternEditableState();
        if (panelType === HINBAN_GENKA_PANEL_TYPE) {
            syncHinbanGenkaCurrencyState(entrydataRef.current, true);
            syncHinbanGenkaPatternByEntry(entrydataRef.current);
            recalcHinbanGenkaGridAndSummary(panel);
        }
        applyKakousijiDetailPostEdit(panel);
        if (isKakousijiPanelType(panelType) || panelType === KAKOUSIJI_ANCHOR_PANEL_TYPE) {
            const targetSsdNo = resolveKakousijiSummaryTargetSsdNo(DicVal(params, 'data', null));
            refreshKakousijiSummaryState(targetSsdNo);
        }
    }
    function ListRowValueChanged(colid, rows, panel) {
        storeRowData(panel);
        const panelType = String(DicVal(panel, "type", "")).trim();
        if (panelType === "200") {
            syncKakousijiSamplePanelsFromPdtc();
        }
        if (panelType === "210") refreshPdtSizePatternEditableState();
        if (matchesColumnToken(colid, "PDTC_COLORCD") && !isEmpty(rows)) {
            rows.forEach((row) => {
                loadColorMasterInfo(DicVal(row, "PDTC_COLORCD", DicVal(row, "PDTC_ColorCd", "")), {
                    silent: true,
                    clearOnNotFound: true,
                    targetData: row,
                    panel: panel
                });
            });
        }
        applyKakousijiDetailPostEdit(panel);
        if (isKakousijiPanelType(panelType) || panelType === KAKOUSIJI_ANCHOR_PANEL_TYPE) {
            const targetSsdNo = resolveKakousijiSummaryTargetSsdNo(DicVal(rows, 0, null));
            refreshKakousijiSummaryState(targetSsdNo);
        }
    }
    function setPriceFieldLocked(locked) {
        const normalizedLocked = !!locked;
        settextfields((prev) => {
            if (isEmpty(prev)) return prev;
            let changed = false;
            const next = prev.map((field) => {
                if (!["PDT_PRICE", "PDTC_PRICE"].includes(field.columnid)) return field;
                if (!!field.locked === normalizedLocked) return field;
                changed = true;
                return { ...field, locked: normalizedLocked };
            });
            return changed ? next : prev;
        });
        settextfieldsall((prev) => {
            if (isEmpty(prev)) return prev;
            let changed = false;
            const next = prev.map((field) => {
                if (!["PDT_PRICE", "PDTC_PRICE"].includes(field.columnid)) return field;
                if (!!field.locked === normalizedLocked) return field;
                changed = true;
                return { ...field, locked: normalizedLocked };
            });
            return changed ? next : prev;
        });
    }
    // 店頭展開日から展開月/展開週を導出して entrydata に反映する。
    // 導出仕様は MD投入表(TenkaiMdHinbanDialog.createShopDateValues)と同一:
    // 展開月="{月}月"・展開週=ISO週番号+"W"(M_PDTMD 側は varchar(5))。日付クリア時は両方クリア。
    function applyShopRolloutFieldsToEntryData(data, rawValue) {
        if (isEmpty(data)) return false;
        const matched = String(rawValue ?? "").match(/^(\d{4})[/-](\d{1,2})[/-](\d{1,2})/);
        let month = "";
        let week = "";
        if (matched !== null) {
            const monthNo = Number(matched[2]);
            const isoDate = new Date(Date.UTC(Number(matched[1]), monthNo - 1, Number(matched[3])));
            const dayOfWeek = isoDate.getUTCDay() || 7;
            isoDate.setUTCDate(isoDate.getUTCDate() + 4 - dayOfWeek);
            const isoYearStart = new Date(Date.UTC(isoDate.getUTCFullYear(), 0, 1));
            const isoWeek = Math.ceil((((isoDate - isoYearStart) / 86400000) + 1) / 7);
            month = `${monthNo}月`;
            week = `${isoWeek}W`;
        }
        if (DicVal(data, "PDTMD_SHOPYMDM", "") === month && DicVal(data, "PDTMD_SHOPYMDW", "") === week) {
            return false;
        }
        data.PDTMD_SHOPYMDM = month;
        data.PDTMD_SHOPYMDW = week;
        return true;
    }
    function ValueChanged(id, value, edit, options) {
        const eventOptions = isEmpty(options) ? {} : options;
        const targetData = isEmpty(DicVal(eventOptions, "targetData", null)) ? entrydataRef.current : DicVal(eventOptions, "targetData", null);
        if (String(id ?? "").trim().toUpperCase() === SUSTAINABLE_IMAGE_FILE_FIELD) {
            loadSustainableImageFromServer({ ...(entrydataRef.current || {}), [id]: value });
        }
        if (handleBrandHinbanSerialSelection(id, value, eventOptions)) {
            value = getEntryDataValue(targetData, BRAND_HINBAN_COLUMNID, value);
        }

        const representativePanelType = resolveKakousijiRepresentativePanelTypeByFieldId(id);
        if (representativePanelType !== '' && targetData === entrydataRef.current) {
            const updates = { [id]: value };
            const displayCode = eventOptions.displayCodeFieldId;
            const displayName = eventOptions.displayNameFieldId;
            if (!isEmpty(displayCode)) updates[displayCode] = DicVal(entrydataRef.current, displayCode, '');
            if (!isEmpty(displayName)) updates[displayName] = DicVal(entrydataRef.current, displayName, '');
            applyKakousijiBaseUpdatesToCurrentContext(representativePanelType, updates);
        }
        if (matchesColumnToken(id, "ROTCHANGEFLG")) {
            if (!isEmpty(entrydataRef.current)) {
                const changed = applyRotRoundRuleToEntryData(entrydataRef.current);
                if (changed || !isEmpty(entrydataRef.current)) {
                    dispatch(entrydata({ ...entrydataRef.current }));
                }
            }
        }
        if (id === "PDT_PRICE" || id === "PDTMD_YOTEIGENKA") {
            if (!isEmpty(entrydataRef.current) && applyCostRateToEntryData(entrydataRef.current)) {
                dispatch(entrydata({ ...entrydataRef.current }));
                dispatch(entryrerender());
            }
        }
        if (id === "PDT_PRICE") {
            if (!isEmpty(entrydataRef.current) && syncMakerHyojyunJyodaiFromPrice(entrydataRef.current)) {
                dispatch(entrydata({ ...entrydataRef.current }));
                dispatch(entryrerender());
            }
        }
        if (id === "PDT_SHOHINKBN") {
            if (!isEmpty(entrydataRef.current) && applyZaikoHyokaKbnFromShohinKbn(entrydataRef.current)) {
                dispatch(entrydata({ ...entrydataRef.current }));
                dispatch(entryrerender());
            }
        }
        if (id === "PDTMD_SHOPYMD") {
            if (!isEmpty(entrydataRef.current) && applyShopRolloutFieldsToEntryData(entrydataRef.current, value)) {
                // 展開月/週(商品情報2)は storeentrydata 購読で表示同期されるため entrydata のみ通知する。
                // entryrerender の全項目再描画はカレンダードロワーの閉じ遷移を遅らせ、
                // 遷移中の再クリック(DatePicker の datainfo 初期化後 Apply)を誘発するため使わない。
                dispatch(entrydata({ ...entrydataRef.current }));
            }
        }
        if (matchesColumnToken(id, "PDTC_COLORCD")) {
            loadColorMasterInfo(value, {
                silent: true,
                clearOnNotFound: true,
                targetData: DicVal(eventOptions, "targetData", null),
                rowNode: DicVal(eventOptions, "rowNode", null),
                panel: DicVal(eventOptions, "panel", null)
            });
        }
        if (matchesColumnId(id, "PDT_BRDCODE") || matchesColumnId(id, "PDT_BRDCODE_cd")) {
            if (!isEmpty(entrydataRef.current)) {
                syncPdtBrandCodeAlias(entrydataRef.current, value);
            }
            if (!isEmpty(entrydataRef.current) && clearPdtTenkaiCodeValue(entrydataRef.current)) {
                dispatch(entrydata({ ...entrydataRef.current }));
                dispatch(entryrerender());
            }
            loadHinbanFixEnableByBrand(value);
            loadUserAllowedBrandDepartment(value);
            loadBrandGroupInfo({ silent: true, clearOnNotFound: true, rerenderOnComplete: true });
            loadQrcSyohinBunruiCd({ silent: true, force: true });
            loadQrcSyohinComent({ silent: true, force: true });
            if (formstatus !== "ENTRY FORM") loadBitmSubCode({ silent: true });
            applyPdtcSizeOptions([]);
            applyPdtSizePatternOptions([]);
            loadPdtSizePatternOptions({ silent: true, targetData: entrydataRef.current, autoSelectFirst: true });
            loadPdtTenkaiCodeOptionsForData(entrydataRef.current, { silent: true });
        }
        if (matchesColumnId(id, SUB_BRAND_COLUMNID)) {
            if (!isEmpty(targetData) && applySubBrandNameToEntryData(targetData)) {
                if (targetData === entrydataRef.current) dispatch(entrydata({ ...entrydataRef.current }));
                dispatch(entryrerender());
            }
        }
        if (id === "PDT_JYUTAKUSIRECD") {
            loadJyutakuSupplierInfo({ silent: true, force: true });
        }
        if (id === "PDT_ITMCITEMCD") {
            const targetData = isEmpty(DicVal(eventOptions, "targetData", null))
                ? entrydataRef.current
                : DicVal(eventOptions, "targetData", null);
            if (!isEmpty(targetData) && clearPdtTenkaiCodeValue(targetData)) {
                if (targetData === entrydataRef.current) {
                    dispatch(entrydata({ ...entrydataRef.current }));
                }
                dispatch(entryrerender());
            }
            loadQrcSyohinBunruiCd({ silent: true, force: true });
            loadQrcSyohinComent({ silent: true, force: true });
            syncItemDependentData({ silent: true });
            loadPdtSizePatternOptions({ silent: true, targetData: targetData, autoSelectFirst: true });
            applyPdtcSizeOptions([]);
            loadPdtTenkaiCodeOptionsForData(targetData, { silent: true });
        }
        if (PDT_SIZE_PATTERN_FIELD_IDS.includes(id)) {
            loadPdtSizePatternSizeOptions(value, {
                silent: true,
                targetData: DicVal(eventOptions, "targetData", null)
            });
        }
        if (id === "PDTC_SIZECD" && isEmpty(currentPdtSizePatternCode({ ...(entrydataRef.current || {}), ...(DicVal(eventOptions, "targetData", null) || {}) }))) {
            fnc.current.warnmsg(PDTC_SIZE_PATTERN_REQUIRED_MESSAGE);
        }
        if (id === "PDT_TENKAICODE") {
            pdtTenkaiCodeChangedAfterLoadRef.current = true;
            refreshPdtSizePatternEditableState();
            loadPdtTenkaiSizePatternInfo(value, {
                silent: true,
                targetData: DicVal(eventOptions, "targetData", null)
            });
        }
        if (id === "PDT_HBSEASONCD") {
            loadJanSeasonCode(value, { silent: true });
        }
        if (id === "PDT_SEASONCD" && !isEmpty(value)) {
            if (lastSeasonValueRef.current === value) return;
            lastSeasonValueRef.current = value;
            // 年度再計算(syncPdtYear)は entrydataRef のシーズンを参照する。呼び出し元によっては
            // この時点で entrydataRef が未更新のことがあるため、変更値を先に書き込んでおく。
            if (!isEmpty(entrydataRef.current)) {
                entrydataRef.current.PDT_SEASONCD = value;
            }
            if (seasonChangeTimerRef.current !== null) {
                clearTimeout(seasonChangeTimerRef.current);
            }
            seasonChangeTimerRef.current = setTimeout(() => {
                seasonChangeTimerRef.current = null;
                refreshControlDate(true);
            }, 0);
        }
        if (shouldRefreshHinbanGenkaByColumnId(id) && !isEmpty(entrydataRef.current)) {
            const genkaChanged = syncHinbanGenkaCurrencyState(entrydataRef.current, true);
            syncHinbanGenkaPatternByEntry(entrydataRef.current);
            if (genkaChanged) {
                dispatch(entrydata({ ...entrydataRef.current }));
                dispatch(entryrerender());
            }
        }
        //外部からの参照がある項目
        let col = columninfo.find(e => e.columnid === id);
        if (!isEmpty(col)) {
            if (col.extriggerref) {
                dispatch(entrytriggercall(id));
            }
        }
        if (targetData === entrydataRef.current && !isEmpty(activeKakousijiSummaryItem()) && shouldSyncKakousijiSummaryByFieldId(id)) {
            refreshKakousijiSummaryState(resolveKakousijiSummaryTargetSsdNo(targetData));
        }
    }

    return {
        applyKakousijiDetailPostEdit,
        ListValueChanged,
        ListRowValueChanged,
        setPriceFieldLocked,
        ValueChanged
    };
}
